/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/address';
import '../../common/location';
import '../../common/currency';
import '../../common/countries';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "identityverifier": {
        "nested": {
          "model": {
            "nested": {
              "BusinessAttributes": {
                "fields": {
                  "businessName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "businessIdentifiers": {
                    "type": "squareup.identityverifier.model.BusinessAttributes.BusinessIdentifier",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "address": {
                    "type": "squareup.common.address.Address",
                    "id": 3,
                    "rule": "optional"
                  },
                  "extendedData": {
                    "type": "squareup.identityverifier.model.BusinessAttributes.ExtendedData",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isActive": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tradingAddress": {
                    "type": "squareup.common.address.Address",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BusinessIdentifier": {
                    "fields": {
                      "businessIdType": {
                        "type": "squareup.identityverifier.model.BusinessIDType",
                        "id": 3,
                        "rule": "optional"
                      },
                      "rawBusinessId": {
                        "type": "string",
                        "id": 1
                      },
                      "businessIdFideliusToken": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "business_id": {
                        "oneof": ["rawBusinessId", "businessIdFideliusToken"]
                      }
                    }
                  },
                  "ExtendedData": {
                    "fields": {
                      "directors": {
                        "type": "squareup.identityverifier.model.BusinessPerson",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "beneficialOwners": {
                        "type": "squareup.identityverifier.model.BusinessPerson",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "businessType": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "phoneNumbers": {
                        "type": "squareup.common.location.Phone",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "websites": {
                        "type": "string",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "industryCodes": {
                        "type": "string",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "sharesCapital": {
                        "type": "squareup.common.Money",
                        "id": 8,
                        "rule": "optional"
                      },
                      "partnerPersons": {
                        "type": "squareup.identityverifier.model.BusinessPerson",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "multiLingualNames": {
                        "type": "squareup.identityverifier.model.MultiLingualName",
                        "id": 10,
                        "rule": "repeated"
                      },
                      "multiLingualAddresses": {
                        "type": "squareup.identityverifier.model.MultilingualAddress",
                        "id": 11,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "MultiLingualName": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "language": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "writingScript": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MultilingualAddress": {
                "fields": {
                  "language": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "writingScript": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  },
                  "addressLocality": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "addressRegion": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "addressLine1": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "addressLine2": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "BusinessIDType": {
                "values": {
                  "DO_NOT_USE_BUSINESS_ID_TYPE": 0,
                  "ABN": 1,
                  "INCORP": 2,
                  "VAT": 3,
                  "SIREN": 4,
                  "SIRET": 5,
                  "EIN": 6,
                  "CIK": 7,
                  "LEI": 8,
                  "TIN": 9,
                  "TRADE_RN": 10,
                  "ACN": 11,
                  "RCS": 12,
                  "NAF": 13,
                  "NIF": 14,
                  "BRN": 15,
                  "CHRN": 16,
                  "CORPORATE_NUMBER": 17
                }
              },
              "BusinessPerson": {
                "fields": {
                  "externalId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "givenName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "familyName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "birthDate": {
                    "type": "squareup.common.time.YearMonthDay",
                    "id": 4,
                    "rule": "optional"
                  },
                  "location": {
                    "type": "squareup.identityverifier.model.BusinessPerson.ShortLocation",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ownershipPercentage": {
                    "type": "float",
                    "id": 6,
                    "rule": "optional"
                  },
                  "multiLingualNames": {
                    "type": "squareup.identityverifier.model.MultiLingualName",
                    "id": 7,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ShortLocation": {
                    "fields": {
                      "city": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "postalCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "country": {
                        "type": "squareup.common.countries.Country",
                        "id": 3,
                        "rule": "optional"
                      },
                      "provinceOrState": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "addressLine1": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "addressLine2": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.BusinessAttributes && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.BusinessAttributes?.nested?.BusinessIdentifier && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.BusinessAttributes?.nested?.ExtendedData && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.MultiLingualName && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.MultilingualAddress && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.BusinessIDType && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.BusinessPerson && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.BusinessPerson?.nested?.ShortLocation) {
  $root.addJSON(jsonData);
}

/**
 * Container of business attributes.
 *
 * SOURCE BusinessAttributes @ squareup/identityverifier/model/business_attributes.proto at 16:1
 */
export const BusinessAttributes = $root.lookupType('squareup.identityverifier.model.BusinessAttributes');
fixType(BusinessAttributes);
Builder.createAndAttachToType(BusinessAttributes);
/**
 * SOURCE BusinessIdentifier @ squareup/identityverifier/model/business_attributes.proto at 22:3
 */
BusinessAttributes.BusinessIdentifier = $root.lookupType('squareup.identityverifier.model.BusinessAttributes.BusinessIdentifier');
fixType(BusinessAttributes.BusinessIdentifier);
Builder.createAndAttachToType(BusinessAttributes.BusinessIdentifier);
/**
 * SOURCE ExtendedData @ squareup/identityverifier/model/business_attributes.proto at 39:3
 */
BusinessAttributes.ExtendedData = $root.lookupType('squareup.identityverifier.model.BusinessAttributes.ExtendedData');
fixType(BusinessAttributes.ExtendedData);
Builder.createAndAttachToType(BusinessAttributes.ExtendedData);
/**
 * SOURCE MultiLingualName @ squareup/identityverifier/model/business_attributes.proto at 61:1
 */
export const MultiLingualName = $root.lookupType('squareup.identityverifier.model.MultiLingualName');
fixType(MultiLingualName);
Builder.createAndAttachToType(MultiLingualName);
/**
 * SOURCE MultilingualAddress @ squareup/identityverifier/model/business_attributes.proto at 67:1
 */
export const MultilingualAddress = $root.lookupType('squareup.identityverifier.model.MultilingualAddress');
fixType(MultilingualAddress);
Builder.createAndAttachToType(MultilingualAddress);
/**
 * SOURCE BusinessIDType @ squareup/identityverifier/model/business_attributes.proto at 78:1
 */
export const BusinessIDType = $root.lookupEnum('squareup.identityverifier.model.BusinessIDType').values;
/**
 * SOURCE BusinessPerson @ squareup/identityverifier/model/business_attributes.proto at 99:1
 */
export const BusinessPerson = $root.lookupType('squareup.identityverifier.model.BusinessPerson');
fixType(BusinessPerson);
Builder.createAndAttachToType(BusinessPerson);
/**
 * SOURCE ShortLocation @ squareup/identityverifier/model/business_attributes.proto at 106:3
 */
BusinessPerson.ShortLocation = $root.lookupType('squareup.identityverifier.model.BusinessPerson.ShortLocation');
fixType(BusinessPerson.ShortLocation);
Builder.createAndAttachToType(BusinessPerson.ShortLocation);